<mat-card>
  <form class="service-form">
    <div class="service-title">
      <div>{{ 'SERVICES.SERVICE_MANAGEMENT' | translate }}</div>
      <ng-content select="[copyButtonToMarket]"></ng-content>
      <mat-checkbox
        class="checkbox-services"
        [checked]="!!servicesConfs?.isEnabled"
        (change)="activateServices($event)"
      ></mat-checkbox>
      {{ 'SERVICES.ACTIVATE_SERVICES' | translate }}
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'SERVICES.SELECT_SERVICES' | translate }}</mat-label>
        <mat-select multiple [value]="displayServicesSelected" (selectionChange)="onSelectionChange($event)">
          <mat-option *ngFor="let service of digitalServicesList" [value]="service">
            {{ service.key }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <app-service-management-row
        *ngFor="let serviceRowForm of servicesFormArray.controls; let i = index"
        [rowIndex]="i"
        [placementIdsList]="placementIdsList"
        [serviceRowForm]="serviceRowForm"
        (formServiceRowChange)="onFormServiceRowChange()"
      >
      </app-service-management-row>
    </div>
  </form>
</mat-card>
